<template>
  <div class="container" v-show="isShowModel">
    <div class="hidden">
      <div class="showModel">
        <div class="model-title">
          <div class="title">{{title}}</div>
          <div class="close" @click="close()">✖</div>
        </div>
        <div class="model-body" style="max-height:350px;overflow-y:scroll">
          <slot name="shop-list"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "showModel",
  props: ["isShowModel","title"],
  data() {
    return {
    };
  },
  created() {},
  methods: {
    close() {
      console.log("关闭");
      this.$emit("close");
    },
  },
};
</script>


<style scoped>
.container {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 9999;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.5);
}
.hidden {
  width: 40%;
  margin: 10% 30%;
  background: #ffffff;
  opacity: 1;
  border-radius: 6px;
  border: 1px solid #d1d1d1;
}
.model-title {
  background: #f5f5f5;
  opacity: 1;
  border-radius: 6px 6px 0px 0px;
  padding: 12px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.model-body {
  padding: 12px 25px 32px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/showModel/showModel.vue